import React, { useEffect, useState } from 'react'
import { IconButton, Typography, Grid, Paper } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import LambdaFetch from '../functions/FetchFromLambda'
import { makeStyles } from '@material-ui/core/styles'
import SimpleAutoComplete from '../functions/SimpleAutoComplete'
import LoadingCircle from '../components/common/LoadingCircle'
import LoadingButton from '../components/LoadingButton'
import ItemDetail from '../components/ItemDetail'
import { smallScreenWidth } from '../constants/AppConstants'
import ServerSideAutoCompletev2 from '../functions/ServerSideAutoCompletev2'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    margin: '1rem 1rem 0 1rem'
  }
}))

export default function Item (props) {
  const classes = useStyles()
  const { credentials } = props.fetchInitialData
  const [state, setstate] = useState({
    itemData: null,
    groups: [],
    fetched: false,
    isFetching: false
  })
  const [headers, setHeaders] = React.useState({
    itemGroup: null,
    item: null
  })

  useEffect(() => {
    async function fetch () {
      try {
        const resp = await LambdaFetch(
          'item',
          'post',
          credentials.user.accessToken,
          JSON.stringify({
            action: 'get-groups'
          }),
          '',
          credentials
        )
        setstate({ ...state, groups: resp.data.groups, fetched: true })
      } catch (e) {
        console.log(e)
      }
    }

    fetch()
  }, [])

  const getItem = async e => {
    e.preventDefault()
    try {
      setstate({ ...state, isFetching: true })

      const resp = await LambdaFetch(
        'item',
        'post',
        credentials.user.accessToken,
        JSON.stringify({  
          action: 'get-item',
          itemGroup: headers.itemGroup,
          item: headers.item
        }),
        '',
        credentials
      )

      setstate({
        ...state,
        itemData: resp.data.item[0],
        isFetching: false
      })
    } catch (e) {
      console.log(e)
    }
  }

  const handleChange = (name, value) => {
    setHeaders({ ...headers, [name]: value })
  }

  const { itemData } = state

  if (!state.fetched) {
    return <LoadingCircle />
  }
  return (
    <div style={{ padding: '1.5rem 0.5rem' }}>
      <IconButton
        style={{ borderRadius: '5px', position: 'absolute' }}
        size='small'
        onClick={() => props.history.push('/')}
        aria-label='delete'
      >
        <ArrowBackIcon />
        {props.fetchInitialData.credentials.appWidth > smallScreenWidth &&
          'Dashboard'}
      </IconButton>
      <Typography variant='h5' style={{ textAlign: 'center' }}>
        Item (IC11)
      </Typography>

      <div className={classes.root}>
        <Paper elevation={0} style={{ padding: '1rem' }}>
          <form onSubmit={getItem}>
            <Grid
              container
              alignContent='center'
              alignItems='flex-start'
              spacing={3}
            >
              <Grid item>
                <SimpleAutoComplete
                  id={'itemGroup'}
                  name={'itemGroup'}
                  width='150px'
                  required={true}
                  variant='standard'
                  label={'Item Group'}
                  value={headers.itemGroup}
                  onChange={val => handleChange('itemGroup', val)}
                  options={state.groups.map(el => el['ITEM_GROUP'])}
                  getOptionLabel={val => val.toString()}
                />
              </Grid>
              <Grid item>
                <ServerSideAutoCompletev2
                  disabled={false}
                  id='item'
                  width='320px'
                  required={true}
                  label='Item'
                  accessToken={credentials.user.accessToken}
                  error='No Item found'
                  variant='standard'
                  handleChange={(id, hit) => {
                    handleChange('item', id)
                  }}
                  credentials={credentials}
                  apiResource='item'
                  secondaryParams={{
                    limit: 25,
                    itemGroup: headers.itemGroup,
                    action: 'item-autocomplete'
                  }}
                />
              </Grid>
            </Grid>
            <div style={{ marginTop: '1rem' }}>
              <LoadingButton
                label='Submit'
                isLoading={state.isFetching}
                color='primaryVLButton'
                buttonType='submit'
              />
            </div>
          </form>
        </Paper>

        {itemData && (
          <Grid
            item
            xs={12}
            style={{ position: 'relative', marginTop: '1rem' }}
          >
            <ItemDetail {...props} itemData={itemData} />
          </Grid>
        )}
      </div>
    </div>
  )
}
